import { Directive, HostListener, HostBinding } from '@angular/core';

@Directive({
    selector: '[appSocial]'
})
export class SocialDirective {
    @HostBinding('class.open') isOpen = false;

    @HostListener('click') toggleOpen() {
        this.isOpen = !this.isOpen;
    }
}
